import { AttributesMixin, define, Model, type } from "@type-r/models";
import { CreditNote } from "./creditNote";

export interface CreditNoteVaultCard extends AttributesMixin<typeof CreditNoteVaultCard> { }
@define
export class CreditNoteVaultCard extends Model {

    static idAttribute = "id";

    static attributes = {
        stateId: Number,
        createdOn: type(Date),
        uid: String,
        dataset: type(CreditNote).dontSave,
        hashKey: String,
        updatedOn: type(Date),
        eTag: String,
        assetTypeId: Number,
        dataSourceId: Number,
        platformCode: String,
        createdBy: String
    };
}